import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class IncidentNotificationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentNotification'}
            title={'PROCEDURE P18.0 INCIDENT NOTIFICATION'}
            exportTitle={'<h2>Procedure P18.0 Incident Notification</h2>'}
            exportFileName={'incident_notification.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentNotificationProcedure);
